import { Navigate } from 'react-router';
import type { ReactNode } from 'react';
import { useAuth } from './context';

export function RequireAuth({ children }: { children: ReactNode }) {
  const auth = useAuth();
  if (!auth.isAuthed) return <Navigate to="/login" replace />;
  return <>{children}</>;
}
